<div *transloco="let t" class="onboarding-page-container">
  <div class="title">
    {{ t('onboarding.fourthPage.title') }}
  </div>
  <div class="promo-ticket-container">
    <div class="inner-promo-ticket">
      <span>{{ t('onboarding.fourthPage.earn') }}</span>
      <span class="pill ticket-pill non-image-pill">{{ cashbackPercent() }}%</span>
      <span>{{ t('onboarding.fourthPage.text') }}</span>
      <lib-pill-logo [companyName]="companyName()"
                     [companyLogo]="companyLogo()"
                     [color]="pillColor.ORANGE_LIGHT"
                     [size]="Size.BIG">
      </lib-pill-logo>
    </div>

  </div>
</div>
